"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = WindowManagerProvider;

var _react = _interopRequireWildcard(require("react"));

var _WindowManagerContext = _interopRequireDefault(require("./WindowManagerContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var WINDOWS_MAX_AMOUNT = 50;
var CASCADE_INCREMENT_PX = 50;
var CASCADE_RESET_ON_INDEX = 3; // amount of iterations/windows until the cascade resets

var AVERAGE_WINDOW_WIDTH_PX = 270;
var AVERAGE_WINDOW_HEIGHT_PX = 500;

function getCascadeForNextIteration(input) {
  var getCenterForWindow = function getCenterForWindow(width, height) {
    var _window = window,
        innerWidth = _window.innerWidth,
        innerHeight = _window.innerHeight;
    var x = innerWidth / 2 - width / 2;
    var y = innerHeight / 2 - height / 2;
    return {
      x: x,
      y: y
    };
  };

  var _getCenterForWindow = getCenterForWindow(AVERAGE_WINDOW_WIDTH_PX, AVERAGE_WINDOW_HEIGHT_PX),
      initialPosX = _getCenterForWindow.x,
      initialPosY = _getCenterForWindow.y;

  var index = 0;
  var posX = initialPosX;
  var posY = initialPosY;

  if (input && input.index <= CASCADE_RESET_ON_INDEX) {
    posX = input.posX + CASCADE_INCREMENT_PX;
    posY = input.posY + CASCADE_INCREMENT_PX;
    index = input.index + 1;
  }

  return {
    index: index,
    posX: posX,
    posY: posY
  };
}

function WindowManagerProvider(_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      windows = _useState2[0],
      setWindows = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      posZ = _useState4[0],
      setPosZ = _useState4[1];

  var _useState5 = (0, _react.useState)(getCascadeForNextIteration()),
      _useState6 = _slicedToArray(_useState5, 2),
      cascade = _useState6[0],
      setCascade = _useState6[1];

  var findIndexOfWindowByWindowId = (0, _react.useCallback)(function (windowId) {
    return windows.findIndex(function (entry) {
      return entry.id === windowId;
    });
  }, [windows]);
  var findWindowByIdAndChangeProps = (0, _react.useCallback)(function (windowId, props) {
    var index = findIndexOfWindowByWindowId(windowId);
    if (index < 0) return undefined;

    var newWindow = _objectSpread(_objectSpread({}, windows[index]), props);

    var newWindows = windows;
    newWindows[index] = newWindow;
    setWindows(newWindows);
    return newWindow;
  }, [findIndexOfWindowByWindowId, windows, setWindows]);
  var openWindow = (0, _react.useCallback)(function (meta) {
    var isCascaded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (windows.length >= WINDOWS_MAX_AMOUNT) return undefined;
    var window = {
      id: windows.length,
      isVisible: true,
      posX: meta.posX || (isCascaded ? cascade.posX : 0),
      posY: meta.posY || (isCascaded ? cascade.posY : 0),
      posZ: posZ,
      component: meta.component
    };
    setWindows(function (prev) {
      return [].concat(_toConsumableArray(prev), [window]);
    });
    setPosZ(function (prev) {
      return prev + 1;
    });
    if (!meta.posX && !meta.posY && isCascaded) setCascade(getCascadeForNextIteration(cascade));
    return window;
  }, [posZ, windows, cascade]);
  var openWindows = (0, _react.useCallback)(function (metas) {
    var isCascaded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var newWindows = [];
    var iterCascade = getCascadeForNextIteration(cascade);
    var iterId = windows.length;
    var iterPosZ = posZ;
    metas.some(function (meta) {
      if (windows.length + newWindows.length >= WINDOWS_MAX_AMOUNT) return true;
      var window = {
        id: iterId,
        isVisible: true,
        posX: meta.posX || (isCascaded ? iterCascade.posX : 0),
        posY: meta.posY || (isCascaded ? iterCascade.posY : 0),
        posZ: iterPosZ,
        component: meta.component
      };
      iterId += 1;
      iterPosZ += 1;

      if (!meta.posX && !meta.posX && isCascaded) {
        iterCascade = getCascadeForNextIteration(iterCascade);
      }

      newWindows.push(window);
      return false;
    });
    setPosZ(iterPosZ);
    setCascade(iterCascade);
    setWindows(windows.concat(newWindows));
    return newWindows;
  }, [cascade, posZ, windows]);
  var closeWindow = (0, _react.useCallback)(function (windowId) {
    var index = findIndexOfWindowByWindowId(windowId);
    if (index < 0) return undefined;
    var window = windows[index];
    setWindows(windows.filter(function (entry) {
      return entry.id !== windowId;
    }));
    return window;
  }, [findIndexOfWindowByWindowId, windows, setWindows]);
  var hideWindow = (0, _react.useCallback)(function (windowId) {
    return findWindowByIdAndChangeProps(windowId, {
      isVisible: false
    });
  }, [findWindowByIdAndChangeProps]);
  var showWindow = (0, _react.useCallback)(function (windowId) {
    return findWindowByIdAndChangeProps(windowId, {
      isVisible: true
    });
  }, [findWindowByIdAndChangeProps]);
  var moveWindow = (0, _react.useCallback)(function (windowId, toX, toY) {
    return findWindowByIdAndChangeProps(windowId, {
      posX: toX,
      posY: toY
    });
  }, [findWindowByIdAndChangeProps]);
  var focusWindow = (0, _react.useCallback)(function (windowId) {
    var newPosZ = posZ + 1;
    setPosZ(newPosZ);
    return findWindowByIdAndChangeProps(windowId, {
      isVisible: true,
      posZ: newPosZ
    });
  }, [findWindowByIdAndChangeProps, posZ, setPosZ]);
  var clean = (0, _react.useCallback)(function () {
    setWindows([]);
    setPosZ(0);
    setCascade(getCascadeForNextIteration());
  }, []);
  var context = {
    currentPosZ: posZ,
    windows: windows,
    openWindow: openWindow,
    openWindows: openWindows,
    closeWindow: closeWindow,
    hideWindow: hideWindow,
    showWindow: showWindow,
    moveWindow: moveWindow,
    focusWindow: focusWindow,
    clean: clean
  };
  return /*#__PURE__*/_react.default.createElement(_WindowManagerContext.default.Provider, {
    value: context
  }, children);
}